import { render, staticRenderFns } from "./_PlayerMonitors.vue?vue&type=template&id=88c18258&"
import script from "./_PlayerMonitors.vue?vue&type=script&lang=ts&"
export * from "./_PlayerMonitors.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports